<template lang="pug">
  main
    NavBarUsuarios
    Loader(v-show="isLoading")
    section.hero(v-show="!isLoading")
      .columns
        .column.is-12
          .container
            .content.has-text-centered
              h3.title Usuarios
              .columns
                .column.is-4
                  .field
                    .control
                      input.input.is-primary(
                        type='text', 
                        placeholder='Buscar por Usario|Cargo',
                        v-model="filter",
                      )
                .column.is-2.has-text-centered
                  span Ordenar por: 
                .column.is-1.has-text-centered(v-show="!isSort_Name_Asc")
                  a.button.is-small(:class=" isSort_Name_Desc ? 'is-dark' : 'is-light' ", @click="changeSort('n', 'asc')") Nombre &nbsp
                    i.fas.fa-chevron-down
                .column.is-1.has-text-centered(v-show="isSort_Name_Asc")
                  a.button.is-small(:class=" isSort_Name_Asc ? 'is-dark' : 'is-light' ", @click="changeSort('n', 'desc')") Nombre &nbsp
                    i.fas.fa-chevron-up
                .column.is-1.has-text-centered(v-show="!isSort_Ubi_Asc")
                  a.button.is-small(:class=" isSort_Ubi_Desc ? 'is-dark' : 'is-light' ", @click="changeSort('u', 'asc')") Ubicación &nbsp
                    i.fas.fa-chevron-down
                .column.is-1.has-text-centered(v-show="isSort_Ubi_Asc")
                  a.button.is-small(:class=" isSort_Ubi_Asc ? 'is-dark' : 'is-light' ", @click="changeSort('u', 'desc')") Ubicación &nbsp
                    i.fas.fa-chevron-up
                .column.is-1.has-text-centered(v-show="!isSort_Cat_Asc")
                  a.button.is-small(:class=" isSort_Cat_Desc ? 'is-dark' : 'is-light' ", @click="changeSort('c', 'asc')") Categoría &nbsp
                    i.fas.fa-chevron-down
                .column.is-1.has-text-centered(v-show="isSort_Cat_Asc")
                  a.button.is-small(:class=" isSort_Cat_Asc ? 'is-dark' : 'is-light' ", @click="changeSort('c', 'desc')") Categoría &nbsp
                    i.fas.fa-chevron-up
                .column.is-offset-.is-2
                  router-link.a.button.is-black.is-rounded(to="/Usuario/Nuevo")
                    | Nuevo
              .columns(v-show="result_filter != ''")
                .column.is-offset-8.is-4
                  span.tag.is-black.is-small {{ result_filter }}
              .columns.is-mobile.is-vcentered
                .column.is-offset-one-fifths-desktop.is-three-fifth-desktop.is-offset-one-quarter-tablet.is-half-tablet.has-text-centered
                  .notification.is-primary(v-show="!usuariosShow.length > 0")
                    button.delete
                    |   Aún no existen usuarios dregistrados.
              .columns(v-show="usuariosShow.length > 0")
                .column.is-offset-1-tablet.is-10-tablet.is-full-mobile.dataTb
                  table#tbRevisiones.table.is-striped.is-responsive
                    thead
                      tr
                        th
                          abbr(title='Número') #
                        th Usuario
                        th Descripción
                        th Ubicación
                        th E-mail
                    tbody
                      tr(v-for="(data, index) in usuariosShow" :key="data.id")
                        td 
                          a.button.is-black.is-rounded.is-small(@click="irDetalleUsuario(data)")
                            | {{ index + 1 }}
                        td
                          span.tag.is-light {{ data.usuario }}
                          br
                          strong.has-text-grey {{ data.nombre }}
                        td(v-html="isJefeArea(data)")
                        td 📌 {{ data.ubicacion }}
                        td {{ data.email }}
            .columns.column-blanco
</template>

<script>
  import NavBarUsuarios from '@/components/usuarios_Componentes/layout/NavBarUsuarios.vue'
  import Loader from '@/components/shared/Loader.vue'
  import usuariosServices from '../../services/usuarios/usuarios'

  export default {
    name: 'HomeUsuarios',
    components: { NavBarUsuarios, Loader },
    data () {
      return {
        usuarios: [],
        usuariosShow: [],
        isLoading: true,
        isSort_Name_Asc: true,
        isSort_Name_Desc: false,
        isSort_Ubi_Asc: false,
        isSort_Ubi_Desc: false,
        isSort_Cat_Asc: false,
        isSort_Cat_Desc: false,
        filter: '',
        result_filter: '',
      }
    },
    watch: {
      sorted () {
        console.log(this.sorted)
      },
      filter () {
        const FILTER_USERS = this.filter.toUpperCase()
        const user_filter = this.usuarios.filter( users => {
          return `${users.nombre} ${users.cargo}`.toUpperCase().includes(FILTER_USERS)
        })
        this.usuariosShow = user_filter
        if (this.filter !== '') {
          this.result_filter = this.usuariosShow.length === 1 ? `Se encontró ${this.usuariosShow.length} coincidencia.` : `Se encontraron ${this.usuariosShow.length} coincidencias.`
        } else {
          this.result_filter = ''
        }
      }
    },
    methods: {
      obtenerUsuarios () {
        usuariosServices.getUsuarios()
          .then(res => {
            this.usuarios = res.filter(user => user.id !== '1539965959482')
            this.usuarios.sort((a,b) => (a.nombre > b.nombre) ? 1 : ((b.nombre > a.nombre) ? -1 : 0))
            this.usuariosShow = this.usuarios
            this.isSort_Name_Asc = true
            
          })
        setTimeout(() => {
          this.isLoading = false
        }, 1000);
      },
      irDetalleUsuario (user) {
        this.isLoading = true
        setTimeout(() => {
          this.isLoading = false
          this.$router.push({ path: `/Usuario/Detalle/${user.id}` })
        }, 750)
      },
      isJefeArea (dataUser) {
        let deptoStr = ''
        let cargoStr = ''
        switch (dataUser.departamento) {
          case '0':
            deptoStr = `<span class="tag is-dark">Administración</span>`
            break
          case '1':
            deptoStr = `<span class="tag is-dark">Instrumentación</span>`
            break
          case '2':
            deptoStr = `<span class="tag is-dark">Administración</span>`
            break
          case '21':
            deptoStr = `<span class="tag is-dark">Contraloría</span>`
            break
          case '22':
            deptoStr = `<span class="tag is-dark">Contabilidad</span>`
            break
          case '23':
            deptoStr = `<span class="tag is-dark">Cuentas por Pagar</span>`
            break
          case '24':
            deptoStr = `<span class="tag is-dark">Fiscal</span>`
            break
          case '3':
            deptoStr = `<span class="tag is-dark">Sistemas y Telec.</span>`
            break
          case '4':
            deptoStr = `<span class="tag is-dark">Operaciones</span>`
            break
          case '5':
            deptoStr = `<span class="tag is-dark">Mantenimiento</span>`
            break
          case '6':
            deptoStr = `<span class="tag is-dark">Sist. e Inst.</span>`
            break
          case '7':
            deptoStr = `<span class="tag is-dark">Seguridad</span>`
            break
          case '71':
            deptoStr = `<span class="tag is-dark">Seguimiento Amb.</span>`
            break
          case '72':
            deptoStr = `<span class="tag is-dark">Regulación</span>`
            break
          case '73':
            deptoStr = `<span class="tag is-dark">Procesos y Proced.</span>`
            break
          case '8':
            deptoStr = `<span class="tag is-dark">Externo</span>`
            break
          case '9':
            deptoStr = `<span class="tag is-dark">Público</span>`
            break
        
          default:
            break
        }

        switch (dataUser.cargo) {
          case '000':
            cargoStr = `<strong>Gerente General</strong>`
            break
          case '001':
            cargoStr = `<strong>Gerente en Planta</strong>`
            break
          case '002':
            cargoStr = `<strong>Gerente en Administración</strong>`
            break
          case '003':
            cargoStr = `<strong>Gerente GIA</strong>`
            break
          case '2100':
            cargoStr = `<strong>Gerente de Contraloría</strong>`
            break
          case '2120':
            cargoStr = `<strong>Asistente de Finanzas</strong>`
            break
          case '2200':
            cargoStr = `<strong>Contador General</strong>`
            break
          case '2220':
            cargoStr = `<strong>Contador Sr.</strong>`
            break
          case '2300':
            cargoStr = `<strong>Tesorería</strong>`
            break
          case '2320':
            cargoStr = `<strong>Analista de Cuentas P.P.</strong>`
            break
          case '2321':
            cargoStr = `<strong>Auxiliar Administrativo</strong>`
            break
          case '2400':
            cargoStr = `<strong>Fiscalista</strong>`
            break
          case '2420':
            cargoStr = `<strong>Usuario Fiscalista</strong>`
            break
          case '2500':
            cargoStr = `<strong>Legal</strong>`
            break
          case '2520':
            cargoStr = `<strong>Usuario Legal</strong>`
            break
          case '7100':
            cargoStr = `<strong>Seguimiento Ambiental</strong>`
            break
          case '7130':
            cargoStr = `<strong>Auxuliar Ambiental</strong>`
            break
          case '7200':
            cargoStr = `<strong>Gerente de Regulación</strong>`
            break
          case '7230':
            cargoStr = `<strong>Auxiliar de Regulación</strong>`
            break
          case '7300':
            cargoStr = `<strong>Ingeniero de Procesos</strong>`
            break
          case '120':
            cargoStr = `<strong>Asistente de Gerencia</strong>`
            break
          case '160':
            cargoStr = `<strong>Asistente de Sistemas e Instrumentación</strong>`
            break
          case '210':
            cargoStr = `<strong>Jefe de Instrumentación</strong>`
            break
          case '220':
            cargoStr = `<strong>Jefe de Administración</strong>`
            break
          case '230':
            cargoStr = `<strong>Jefe de Sistemas y Telec.</strong>`
            break
          case '240':
            cargoStr = `<strong>Jefe de Operaciones</strong>`
            break
          case '250':
            cargoStr = `<strong>Jefe de Mantenimiento</strong>`
          case '270':
            cargoStr = `<strong>Jefe de Seguridad</strong>`
          case '300':
            cargoStr = `<strong>Usuario de Administración</strong>`
            break
          case '310':
            cargoStr = `<strong>Usuario de Instrumentación</strong>`
            break
          case '320':
            cargoStr = `<strong>Usuario de Administración</strong>`
            break
          case '330':
            cargoStr = `<strong>Usuario de Sist.y Telec.</strong>`
            break
          case '331':
            cargoStr = `<strong>Almacenista GIA</strong>`
            break
          case '332':
            cargoStr = `<strong>Almacenista de Sist. y Telec.</strong>`
            break
          case '340':
            cargoStr = `<strong>Usuario de Operaciones</strong>`
            break
          case '341':
            cargoStr = `<strong>Usuario de Facturación</strong>`
            break
          case '342':
            cargoStr = `<strong>Usuario de Báscula</strong>`
            break
          case '343':
            cargoStr = `<strong>Usuario de Báscula y Fact.</strong>`
            break
          case '344':
            cargoStr = `<strong>OPIB</strong>`
            break
          case '350':
            cargoStr = `<strong>Usuario de Mantenimiento</strong>`
            break
          case '370':
            cargoStr = `<strong>Usuario de Seguridad</strong>`
            break
          case '410':
            cargoStr = `<strong>Pasante de Instrumentación</strong>`
            break
          case '530':
            cargoStr = `<strong>Pasante de Sistemas</strong>`
            break
          case '880':
            cargoStr = `<strong>Usuario Propangol</strong>`
            break
          case '881':
            cargoStr = `<strong>Usuario Movenergy</strong>`
            break
          case '882':
            cargoStr = `<strong>Usuario Nieto</strong>`
            break
          case '883':
            cargoStr = `<strong>Usuario Metroplitano</strong>`
            break
          case '884':
            cargoStr = `<strong>Usuario Uribe</strong>`
            break
          case '885':
            cargoStr = `<strong>Usuario Mabarak</strong>`
            break
          case '886':
            cargoStr = `<strong>Usuario Sonigas</strong>`
            break
          case '990':
            cargoStr = `<strong>Usuario Público</strong>`
            break
        
          default:
            break
        }
        return `${cargoStr}<br/>${deptoStr}`
      },
      changeSort (tipo, direccion) {
        console.log(tipo)
        
        switch (tipo) {
          case 'n':
            if (direccion === 'asc') {
              this.isSort_Name_Asc = true
              this.isSort_Name_Desc = false
              this.isSort_Ubi_Asc = false
              this.isSort_Ubi_Desc = false
              this.isSort_Cat_Asc = false
              this.isSort_Cat_Desc = false

              this.usuarios.sort((a,b) => (a.nombre > b.nombre) ? 1 : ((b.nombre > a.nombre) ? -1 : 0))

            } else {
              this.isSort_Name_Asc = false
              this.isSort_Name_Desc = true
              this.isSort_Ubi_Asc = false
              this.isSort_Ubi_Desc = false
              this.isSort_Cat_Asc = false
              this.isSort_Cat_Desc = false
              this.usuarios.sort((a,b) => (a.nombre > b.nombre) ? -1 : ((b.nombre > a.nombre) ? 1 : 0))
            }
            break
          case 'u':
            if (direccion === 'asc') {
              this.isSort_Name_Asc = false
              this.isSort_Name_Desc = false
              this.isSort_Ubi_Asc = true
              this.isSort_Ubi_Desc = false
              this.isSort_Cat_Asc = false
              this.isSort_Cat_Desc = false

              this.usuarios.sort((a,b) => (a.ubicacion > b.ubicacion) ? 1 : ((b.ubicacion > a.ubicacion) ? -1 : 0))

            } else {
              this.isSort_Name_Asc = false
              this.isSort_Name_Desc = false
              this.isSort_Ubi_Asc = false
              this.isSort_Ubi_Desc = true
              this.isSort_Cat_Asc = false
              this.isSort_Cat_Desc = false
              this.usuarios.sort((a,b) => (a.ubicacion > b.ubicacion) ? -1 : ((b.ubicacion > a.ubicacion) ? 1 : 0))
            }
            break
          case 'c':
            if (direccion === 'asc') {
              this.isSort_Name_Asc = false
              this.isSort_Name_Desc = false
              this.isSort_Ubi_Asc = false
              this.isSort_Ubi_Desc = false
              this.isSort_Cat_Asc = true
              this.isSort_Cat_Desc = false

              this.usuarios.sort((a,b) => (a.categoria > b.categoria) ? 1 : ((b.categoria > a.nombre) ? -1 : 0))

            } else {
              this.isSort_Name_Asc = false
              this.isSort_Name_Desc = false
              this.isSort_Ubi_Asc = false
              this.isSort_Ubi_Desc = false
              this.isSort_Cat_Asc = false
              this.isSort_Cat_Desc = true
              this.usuarios.sort((a,b) => (a.categoria > b.categoria) ? -1 : ((b.categoria > a.categoria) ? 1 : 0))
            }
            break
        
          default:
            break
        }
      }
    },
    created () {
      this.obtenerUsuarios()
    }
  }
</script>

<style lang="css" scoped>
  .container {
    padding: 40px 0;
  }

  .column-blanco {
    padding-bottom: 120px;
  }

  @media screen and (max-width: 800px)
  {
    .is-responsive {
      width: 100%;
      border-collapse: collapse;
      border-spacing: 0;
      display: block;
      position: relative;
    }
    td:empty:before {
      content: '\00a0';
    }

    th, td {
      margin: 0;
      vertical-align: top
    }

    th {
      text-align: left;
    }

    thead {
      border-right: solid 2px gray;
      display: block;
      float: left;
    }
    tr {
      display: block;
      padding: 0 10px 0 0;
    }

    th::before {
      content: "\00a0";
    }

    td, th {
      border-width: 0 0 1px;
    }

    tbody {
      display: block;
      width: auto;
      position: relative;
      overflow-x: auto;
      white-space: nowrap;
    }

    tr {
      display: inline-block;
      vertical-align: top;
    }

    th {
      display: block;
      text-align: right;
    }

    td {
      display: block;
      min-height: 1.25em;
      text-align: left;
    }
  }

  @media (min-width:320px) and (orientation: portrait) {
    .botonesPrevNext, .dataTb {
      width: 50vh;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/usuarios_Componentes/HomeUsuarios.vue